import { Image } from "react-bootstrap";
import likeDislikeIcon from "../../assets/images/resume/like-dislike.svg";
import likeIcon from "../../assets/images/resume/likeIcon.svg";
import dislikeIcon from "../../assets/images/resume/dislikeIcon.svg";
import question from "../../assets/images/resume/question.svg";
import "../../assets/scss/components/sections/resumes/feedback.scss";
import { useState } from "react";
import FeedbackModal from "../../components/templates/feedbackModal";
import {
  isTokenPresent,
  removeLocalStorage,
  setLocalStorage,
} from "../../utils/userHelper";
import { useNavigate } from "react-router-dom";

const Feedback = ({ text, resumeId, resumeSlug }) => {
  const navigate = useNavigate();
  const [openCustomModal, setCustomModal] = useState(false);
  const [likeDislikeValue, setLikeDislikeValue] = useState(null);
  const handleModal = () => {
    if (isTokenPresent()) {
      setCustomModal(!openCustomModal);
      removeLocalStorage("feedbackResumeId");
      removeLocalStorage("feedbackResumeSlug");
    } else {
      setLocalStorage("feedbackResumeId", resumeId);
      setLocalStorage("feedbackResumeSlug", resumeSlug);
      navigate("/login");
    }
  };
  return (
    <>
      <div className="feedback">
        <div className="d-flex align-items-center">
          <Image src={question} className="me-3" />
          <h6 className="heading-6">{text}</h6>
        </div>
        <div className="icons-buttons">
          <btn
            className="icons"
            onClick={() => {
              setLikeDislikeValue(1);
              handleModal();
            }}
          >
            <Image src={likeIcon} />
          </btn>
          <btn
            className="icons"
            onClick={() => {
              setLikeDislikeValue(0);
              handleModal();
            }}
          >
            <Image src={dislikeIcon} />
          </btn>
        </div>
      </div>
      <FeedbackModal
        showmodal={openCustomModal}
        closemodal={handleModal}
        redirect={true}
        feedbackValue={likeDislikeValue}
        feedbackObject={"resume"}
        resumeId={resumeId}
      />
    </>
  );
};

export default Feedback;
